import { Card, Col, Divider, Form, Input, Button, Row, message, Checkbox } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import ConsultHeaderCard from "../../../../components/Common/Cards/ConsultHeaderCard";
import { isValidValue, setFormFieldValue } from "../../../../helpers/FormHelper";
import { getErrorMessage } from "../../../../helpers/ErrorHelper";
import { useSelector } from "react-redux";
import DiasporaReferenceService from "../../../../services/Diaspora/DiasporaReferenceService";
import { getFullName } from "../../../../helpers/ObjectHelper";
import moment from "moment";



const initialChecks = {
    perRegistered: false,
    envelopeReceived: false,
    voted: false,
};



const UpdateVotingStatus = ({ item, onBack, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [checks, setChecks] = useState(initialChecks);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            name: getFullName(item?.voter),
            surname: setFormFieldValue(item?.voter?.surname),
            father_name: setFormFieldValue(item?.voter?.father_name),
            birthdate: isValidValue(item?.voter?.dob) ? moment(item?.voter?.dob).format("DD-MM-YYYY") : null,
            region: setFormFieldValue(item?.voter?.region?.name),
            municipality: setFormFieldValue(item?.voter?.municipality?.name),
            unit: setFormFieldValue(item?.voter?.unit?.name),
            phone: setFormFieldValue(item?.emigrant_phone),
            country: setFormFieldValue(item?.country?.country_name),
            city: setFormFieldValue(item?.emigrant_city),
            zip: setFormFieldValue(item?.zip_code),
            note: setFormFieldValue(item?.note),
            referuesName: setFormFieldValue(item?.referues_name),
            referuesSurname: setFormFieldValue(item?.referues_surname),
            referuesPhone: setFormFieldValue(item?.referues_phone),
        });
        setChecks({
            perRegistered: item?.per_registered ?? false,
            envelopeReceived: item?.envelope_received ?? false,
            voted: item?.voted ?? false,
        })
    }, [form, item]);


    const formatRequestData = (data) => {
        return {
            per_registered: checks.perRegistered,
            envelope_received: checks.envelopeReceived,
            voted: checks.voted,
        };
    };


    const onUpdate = async () => {
        try {
            setSubmitLoading(true);
            const data = await form.validateFields();
            const requestData = formatRequestData(data);
            const referenceId = setFormFieldValue(item?.id);
            const response = await DiasporaReferenceService.updateVotingStatus(token, requestData, referenceId);
            const responseData = response.data;
            if (responseData) {
                await message.success('Statusi i votimit u azhornua me sukses!', 1);
                onSuccess();
            } else {
                const errorMessage = 'Një gabim ndodhi gjatë azhornimit të statusit të votimit!';
                await message.error(errorMessage, 2);
            }
        } catch (error) {
            if (error?.values) {
                setSubmitLoading(false);
                return;
            }
            const errorMessage = getErrorMessage(error);
            await message.error(errorMessage, 2);
        } finally {
            setSubmitLoading(false);
        }
    };


    const onCheckboxChange = (event, checkType) => {
        const isChecked = event.target.checked;
        setChecks({ ...checks, [checkType]: isChecked });
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24} className="mb-3">
                    <Col span={24}>
                        <ConsultHeaderCard
                            longTitle="Jeni duke modifikuar statusin e votimit të diasporës"
                            shortTitle="Refrencë diaspore"
                            onBack={onBack}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card style={{ borderRadius: "0" }}>
                            <Form form={form} labelAlign="left" labelCol={{ span: 8 }} layout="horizontal">
                                <Row gutter={24}>
                                    <Col span={24}>
                                        {/* VOTER */}
                                        <Row gutter={24}>
                                            <Col span={24}>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <h5 className="font-weight-bold">
                                                            Të dhënat e votuesit
                                                        </h5>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Divider className="w-100 mt-0" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} align="top" className="m-0">
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="name" label="Emri">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="father_name" label="Atësia">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="birthdate" label="Datëlindja">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={4} lg={4} md={24} sm={24} xs={24} />
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="region" label="Qarku">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="municipality" label="Bashkia">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="unit" label="Nj. administrative">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/* EMIGRANT */}
                                        <Row gutter={24} className="mt-4">
                                            <Col span={24}>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <h5 className="font-weight-bold">
                                                            Të dhëna shtesë
                                                        </h5>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Divider className="w-100 mt-0" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} className="m-0">
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="phone" label="Telefoni">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="country" label="Shteti i emigrimit">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="city" label="Qyteti i emigrimit">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="zip" label="Kodi postar">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="note" label="Shënime">
                                                            <Input.TextArea rows={2} type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={4} lg={4} md={24} sm={24} xs={24} />
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="perRegistered" label="Regjistruar në PER">
                                                            <Checkbox
                                                                checked={checks.perRegistered}
                                                                onChange={(event) => onCheckboxChange(event, 'perRegistered')}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item name="envelopeReceived" label="Ka marrë zarfin">
                                                            <Checkbox
                                                                checked={checks.envelopeReceived}
                                                                onChange={(event) => onCheckboxChange(event, 'envelopeReceived')}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item name="voted" label="Ka votuer">
                                                            <Checkbox
                                                                checked={checks.voted}
                                                                onChange={(event) => onCheckboxChange(event, 'voted')}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider className="w-100" />
                                    </Col>
                                </Row>
                                <Row gutter={24} className="p-2">
                                    <Col xl={8} lg={8} md={4} sm={0} xs={0} />
                                    <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                        <Button
                                            block
                                            type="primary"
                                            loading={submitLoading}
                                            style={{ height: "37px" }}
                                            icon={<CheckOutlined />}
                                            onClick={onUpdate}
                                        >
                                            Ruaj
                                        </Button>
                                    </Col>
                                    <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                        <Button
                                            block
                                            danger
                                            disabled={submitLoading}
                                            style={{ height: "37px" }}
                                            icon={<CloseOutlined />}
                                            onClick={onBack}
                                        >
                                            Mbyll
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default UpdateVotingStatus;